import * as t from "io-ts";
import nullable from "./nullable";
export const addCmrConfigT = t.intersection([
    t.strict({
        pickupId: t.string,
        dropoffId: nullable(t.string),
    }),
    t.partial({
        id: t.string,
    }),
]);
export const cmrConfigT = t.intersection([
    addCmrConfigT,
    t.strict({ id: t.string }),
]);
export const driverCmrConfigT = t.strict({
    id: t.string,
    from: t.string,
    to: nullable(t.string),
});
export const driverCmrConfigsT = t.array(driverCmrConfigT);
//# sourceMappingURL=cmr-config.js.map